module.exports = __webpack_public_path__ + "img/site_31.ba9a0290.png";